import { tWithKeyAttr as t } from "../../i18nHelper";
import popupStyles from "./chatConfirmationPopup.module.css";

function ChatConfirmationPopup({
  setShowModal,
}: {
  setShowModal: (show: boolean) => void;
  setIsVenchyTalking: (isTalking: boolean) => void;
  refAudio: React.MutableRefObject<HTMLAudioElement | null>;
}) {
  return (
    <article className={popupStyles.popup} data-testid="success-popup">
      <h2 className={popupStyles.popup__title}>{t('LET_S_START_CHATTING')}</h2>
      <button
        className={`button hover ${popupStyles.popup__nextBtn}`}
        data-testid="success-popup-ok-button"
        onClick={() => {
          setShowModal(false);
        }}
      >
        {t("CONFIRM")}
      </button>
    </article>
  );
}
export default ChatConfirmationPopup;
